import { MutationUpdaterFn } from "@apollo/client"
import CustomButton, { CustomButtonProps } from "components/Atoms/CustomButton"
import {
  AddUpdateVehicleMutationMutation,
  AddUpdateVehicleMutationMutationVariables,
  useAddUpdateVehicleMutationMutation,
} from "generated/graphql"
import { VEHICLE_MASTER_LIST } from "graphql/vehicle/vehicle.queries.gql"
import React, { useCallback } from "react"
import AppToaster from "utils/AppToaster"
import { graphqlError } from "utils/parseError"

type VehicleMutationProps = CustomButtonProps & {
  errors?: any
  variables: AddUpdateVehicleMutationMutationVariables
  onCompleted?: (data: AddUpdateVehicleMutationMutation) => void
  update?: MutationUpdaterFn<AddUpdateVehicleMutationMutation>
}
const VehicleMutation = ({
  variables,
  onCompleted,
  update,
  errors,
  ...otherProps
}: VehicleMutationProps) => {
  const [addUpdateVehicle, { loading }] = useAddUpdateVehicleMutationMutation({
    onCompleted,
    update,
    refetchQueries: [
      {
        query: VEHICLE_MASTER_LIST,
        variables: {
          departmentId: null,
          first: 12,
          query: "",
          skip: 0,
        },
      },
    ],
    onError(err) {
      AppToaster.show({
        message: graphqlError(err.message),
        intent: "danger",
        icon: "cross",
      })
    },
  })

  const handleClick = useCallback(() => {
    if (errors?.latest) {
      AppToaster.show({
        message: errors.latest,
        intent: "danger",
        icon: "cross",
      })
      return
    }
    addUpdateVehicle({ variables })
  }, [addUpdateVehicle, variables, errors])
  return (
    <CustomButton
      className="ml-3"
      loading={loading}
      onClick={handleClick}
      {...otherProps}
    />
  )
}

export default VehicleMutation
